// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"SupplierWiseAPIPurchasePendingPage_headerActions__2ByyU"};